import { Card, FCC, FlatIconButton, IconButton } from "@dgs/core";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const TravelCard = styled(Card).attrs({ $variant: "outlined" as const })`
	position: relative;
	padding: ${({ theme }) => theme.spacing(4)};
`;

export const TwoColumnCard = styled(TravelCard)`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${({ theme }) => theme.spacing(4)};
`;

const TopRight = styled.div`
	position: absolute;
	display: flex;
	gap: ${({ theme }) => theme.spacing(1)};
	top: ${({ theme }) => theme.spacing(2)};
	right: ${({ theme }) => theme.spacing(2)};
`;

export const CardBody = styled.div`
	padding: ${({ theme }) => theme.spacing(6)} 0;
`;

export const CardFooter = styled.div`
	display: flex;
	justify-content: space-between;
	padding-top: ${({ theme }) => theme.spacing(6)};

	border-top: 1px solid ${({ theme }) => theme.colors.palette.grey[20]};
`;

export const Strong = styled.strong`
	font-size: 20px;
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;

interface CardHeaderProps {
	onRemove?: () => void;
	onEdit?: () => void;
}

export const CardHeader: FCC<CardHeaderProps> = ({ onRemove, onEdit, children }) => {
	const { t } = useTranslation();

	return (
		<div>
			<Strong>{children}</Strong>
			<TopRight>
				{onEdit && <IconButton title={t("Edit")} size="small" icon="edit" onClick={onEdit} type="button" />}
				{onRemove && <FlatIconButton title={t("Remove")} size="small" icon="close" onClick={onRemove} type="button" />}
			</TopRight>
		</div>
	);
};
